import React from 'react';
import Radium from 'radium';
import { func, bool } from 'prop-types';
import { UTLabel, WithLoading, UTLoading } from '@widergy/energy-ui';

import UTTable from 'app/components/UTTable';
import { formResponsePropTypes } from 'redux/userFormHandlers';
import { activeRowSize, inactiveRowSize } from 'constants/sizes';
import { DefaultViewport, MobileViewport } from 'constants/deviceSizes';
import { PROCEDURE } from 'constants/userForms';
import withErrorScreen from 'app/components/UTErrorScreen/HOCs/withErrorScreen';
import { message } from 'utils/stringUtils';

import MobileList from '../../components/FormsMobileList';
import FieldDetail from '../../components/FieldDetail';

import styles from './styles';

/* eslint-disable react/prop-types */
const statusRenderer = ({ cellData, rowData }) => (
  <UTLabel error={rowData.status.isPending} semibold={rowData.status.isPending}>
    {cellData}
  </UTLabel>
);

const typeRenderer = ({ cellData }) => (
  <div style={styles.formType}>
    <UTLabel>{cellData.form_name}</UTLabel>
    <UTLabel darkGray small>
      {cellData.form_category_name}
    </UTLabel>
  </div>
);

/* eslint-enable react/prop-types */
const columns = [
  { key: 'started_at', name: message('Procedures:initDate'), width: 0.2 },
  {
    key: 'status_label',
    name: message('Commons:status'),
    width: 0.17,
    cellRenderer: statusRenderer
  },
  {
    key: 'form_description',
    name: message('Commons:type'),
    width: 0.32,
    cellRenderer: typeRenderer
  },
  { key: 'id', name: message('Procedures:number'), width: 0.13 }
];

function ProceduresScene({ procedures, onCancel, onReiteration, onRowsRendered, appending }) {
  return (
    <div style={styles.table}>
      <DefaultViewport>
        <UTTable
          columns={columns}
          rows={procedures}
          openable
          renderActiveRow={(rowData, positionStyle) => (
            <FieldDetail
              rowData={rowData}
              style={positionStyle}
              onCancel={onCancel}
              onReiteration={onReiteration}
            />
          )}
          activeRowStyle={styles.activeRowStyle}
          rowHeight={(index, activeRowIndex) => (index === activeRowIndex ? activeRowSize : inactiveRowSize)}
          id={PROCEDURE}
          onRowsRendered={onRowsRendered}
          scrolleable
        />
      </DefaultViewport>
      <MobileViewport>
        <MobileList rows={procedures} onCancel={onCancel} onReiteration={onReiteration} />
      </MobileViewport>
      {appending && (
        <div style={styles.spinnerContainer}>
          <UTLoading loading={appending} size={45} text=" " />
        </div>
      )}
    </div>
  );
}

ProceduresScene.propTypes = {
  procedures: formResponsePropTypes,
  onCancel: func.isRequired,
  onReiteration: func.isRequired,
  onRowsRendered: func.isRequired,
  appending: bool
};

export default WithLoading(props => props.loading)(
  withErrorScreen(props => !props.procedures.length)(Radium(ProceduresScene))
);
